import { Component, OnInit, Input, Inject, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl } from '@angular/forms';
import { DataSharedService } from '../../../../shared/services/data-shared.service';


@Component({
	selector: 'app-modal-tipos-solicitud-subcategoria',
	templateUrl: './modal-tipos-solicitud-subcategoria.component.html',
	styleUrls: ['./modal-tipos-solicitud-subcategoria.component.scss']
})
export class ModalTiposSolicitudSubcategoriaComponent implements OnInit {
	@Input() 
	habilitatiposolicitud: Array<any> = [];
	formControl: FormControl;
	@Input()
	tipoSolicitud: any = [];
	selectedValue: any = [];



	constructor(private activeModal: NgbActiveModal, 
				private formBuilder: FormBuilder,
				private dataSharedService: DataSharedService) {
		this.formControl = formBuilder.control('');
	}

	ngOnInit() {
		for (let index = 0; index < this.habilitatiposolicitud.length; index++) {
			const element = this.habilitatiposolicitud[index];
			
			if (element.habilitatiposolicitud) {
				this.selectedValue.push(
						element.tipo_solicitud_id
				)
				
			}
		}
	}
	
	confirm(): void {
		if (this.activeModal) {
			this.activeModal.close(this.formControl.value);
		}
	}

	onDismiss(): void {
		if (this.activeModal) {
			this.activeModal.dismiss();
		}
	}
	
	
}
